export default "__VITE_ASSET__DAnE95Z8__"